/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

/* action type */
export const GET_OBJECT = 'GET_OBJECT';

/* action creator */
export const getObjectAction = (actionPayload: { [key: string]: any }) => {
  return {
    type: GET_OBJECT,
    payload: actionPayload
  };
};
